$(document).ready(function() {
    if(!document.querySelector('.GPC0156')) return false;
    var redemption = {
        modelList               : JSON.parse($("input[name='modelList']", ".GPC0156").val())
        , subCategoryMessage    : $("select[name='subCategoryId']", ".GPC0156").eq(0).find("option").eq(0).text()
        , modelNameMessage      : $("select[name='modelId']", ".GPC0156").eq(0).find("option").eq(0).text()
        , receiptClone          : null
        , serialClone           : null
        , editReceiptClone      : null
        , editSerialClone       : null
        , customerInfo          : null
        , customerModelList     : null
        , customerFileList      : null
        , mailFlag              : null
        // LGEUK-1045 Start
        , useProductSubCategory : $("input[name='useProductSubCategory']", ".GPC0156").val() == 'Y' ? true : false
        , rewardCashBackArea    : $(".choice-box[data-reward-cash='Y']", ".claim-step2-area")
        , rewardCashBackModal   : $("#modal_redemption_check_bank")
        , rewardCashBackFlag    : null
        , editProductRowClone   : $("#editProductRow").clone().html()
        , editCustomerProductRowClone : $("#editCustomerProductRow").clone().html()
        , customerDeleteModels : []
        // LGEUK-1045 End
        , init : function(){
            redemption.tab_ui();
            redemption.bg_load();
            redemption.bg_resize();
            redemption.setBtnEvent();
            
            $("input[name='modelList']", ".GPC0156").remove();
            $("#editProductRow, #editCustomerProductRow").remove(); // LGEUK-1045
            
            $("#purchaseDate", "#claimNow").datepicker("option", "maxDate", 0);
            $("#editPurchaseDate", "#modal-redemption-edit-purchase").datepicker("option", "maxDate", 0);

            receiptArea         = $(".receipt-clone-area", ".receipt-file-area");
            serialArea          = $(".serial-clone-area", ".serial-file-area");
            editReceiptArea     = $(".edit-receipt-clone-area", ".edit-receipt-file-area");
            editSerialArea      = $(".edit-serial-clone-area", ".edit-serial-file-area");
            
            redemption.rewardCashBackFlag = $("input[name='redemptionCashbackUseFlag']").val() == "Y" && redemption.rewardCashBackArea.length && redemption.rewardCashBackModal.length ? true : false; // LGEUK-1045
            redemption.receiptClone     = receiptArea.eq(0).clone(true);
            redemption.serialClone      = serialArea.eq(0).clone(true);
            redemption.editReceiptClone = editReceiptArea.eq(0).clone(true);
            redemption.editSerialClone  = editSerialArea.eq(0).clone(true);
            
            redemption.fileAttrUpdate(receiptArea, redemption.receiptClone.clone(true));
            redemption.fileAttrUpdate(serialArea, redemption.serialClone.clone(true));
            redemption.fileAttrUpdate(editReceiptArea, redemption.editReceiptClone.clone(true));
            redemption.fileAttrUpdate(editSerialArea, redemption.editSerialClone.clone(true));
            
            redemption.mailFlag = redemption.getParameterByName("mailFlag");
            
            if (redemption.mailFlag != null && redemption.mailFlag != "") {
                redemption.mailMoveToTrack();
            }
            
            $(".fileupload-init").attr("data-multi-length", $(".redemption-model-list", ".GPC0156").length);

            // LGEUK-1045 Start
            $("input[type='tel']", ".claim-step2-area").on('input', function(e) {
                $(this).val($(this).val().replace(/[^0-9]/g, ''));
            });
            // LGEUK-1045 End

            // LGEITF-999 Start
            const verUrlList = $('.icon-item-list').data();
            for(verNum in verUrlList){
                if(location.pathname === verUrlList[verNum]){
                    const verClassName = verNum.substr(0, 2);
                    $('.icon-item .subject').hide();
                    $('.icon-item .subject.'+verClassName).show();
                }
            };
            // LGEITF-999 End
        },
        // LGEUK-1045 Start
        claimNowSubmit : function() {
            var formData            = new FormData();
            var params              = {};
            var customerModels      = [];
            var receiptFileUpload   = $(".receipt-file-upload");
            var serialFileUpload    = $(".serial-file-upload");
            
            params.redemptionId     = $("input[name='redemptionId']", ".GPC0156").val();
            params.title            = $("select[name='title'] option:selected", "#claimStep1Form").val();
            params.firstName        = $("input[name='firstName']", "#claimStep1Form").val();
            params.lastName         = $("input[name='lastName']", "#claimStep1Form").val();
            params.emailAddress     = $("input[name='emailAddress']", "#claimStep1Form").val();
            params.mobilePhone      = $("input[name='mobilePhone']", "#claimStep1Form").val();
            params.telephone        = $("input[name='telephone']", "#claimStep1Form").val();
            params.address          = $("input[name='address']", "#claimStep1Form").val();
            params.purchasePlace    = $("input[name='purchasePlace']", "#claimStep1Form").val();
            params.purchaseDate     = $("input[name='purchaseDate']", "#claimStep1Form").val();
            params.rewardName       = $("input[name='redemptionReward']:checked", ".GPC0156").data("reward-name");
            params.rewardType       = $("input[name='redemptionReward']:checked", ".GPC0156").data("reward-type");
            params.rewardOrderNo    = Number($("input[name='redemptionReward']:checked", ".GPC0156").data("reward-order-no"));
            params.useFile          = $("input[name='useFile']", ".GPC0156").val();
            params.useTitle         = $("input[name='useTitle']", ".GPC0156").val();
            params.useFirstName     = $("input[name='useFirstName']", ".GPC0156").val();
            params.useLastName      = $("input[name='useLastName']", ".GPC0156").val();
            params.useMobile        = $("input[name='useMobile']", ".GPC0156").val();
            params.useTelephone     = $("input[name='useTelephone']", ".GPC0156").val();
            params.useAddress       = $("input[name='useAddress']", ".GPC0156").val();
            params.redemptionUrl    = $(location).attr("href") + "?mailFlag=Y";
            
            params.bankHolderName   = $("input[name='bankHolderName']", ".claim-step2-area").val();
            params.bankAccountNumber= $("input[name='bankAccountNumber']", ".claim-step2-area").val();
            params.sortCode         = $("input[name='sortCode']", ".claim-step2-area").val();
            params.sortCode2        = $("input[name='sortCode2']", ".claim-step2-area").val();
            params.sortCode3        = $("input[name='sortCode3']", ".claim-step2-area").val();
            params.bankCurrency     = $("input[name='bankCurrency']", ".claim-step2-area").val(); // LGCOMUK-41

            $('.claim-agreement input').each(function(){
                const agreeName = $(this).attr('name');
                const agreeFlag = $(this).prop('checked') ? 'Y' : 'N';
                params[agreeName] = agreeFlag;
            });
            
            $(".redemption-model-list", "#claimStep1Form").each(function() {
                var customerModel   = {};
                customerModel.categoryId    = $("select[name='categoryId']", $(this)).val();
                customerModel.subCategoryId = $("select[name='subCategoryId']", $(this)).val();
                customerModel.modelId       = $("select[name='modelId'] option:selected", $(this)).val();
                customerModel.modelName     = $("select[name='modelId'] option:selected", $(this)).text();
                customerModel.serialNumber  = $("input[name='serialNumber']", $(this)).val();
                customerModel.purchasedPrice = $("input[name='purchasedPrice']", $(this)).val(); // LGCOMUK-41
                
                customerModels.push(customerModel);
            });
            
            params.customerModels   = customerModels;
            
            for (var i = 0; i < receiptFileUpload.length; i++) {
                if (receiptFileUpload[i].files.length > 0) {
                    for (var j = 0; j < receiptFileUpload[i].files.length; j++) {
                        formData.append('receiptFiles', $('.receipt-file-upload')[i].files[j]);
                    }
                }
            }
            
            for (var i = 0; i < serialFileUpload.length; i++) {
                if (serialFileUpload[i].files.length > 0) {
                    for (var j = 0; j < serialFileUpload[i].files.length; j++) {
                        formData.append('serialFiles', $('.serial-file-upload')[i].files[j]);
                    }
                }
            }
            
            formData.append("params", JSON.stringify(params));
            
            $(".GPC0156").trigger("ajaxLoadBefore");
            
            $.ajax({
                type:"POST",
                url: $("input[name='redemptionInfoSaveUrl']", ".GPC0156").val(),
                processData: false,
                contentType: false,
                enctype : 'multipart/form-data',
                data: formData,
                success: function(d){
                    var claimReference  = d.data[0].claimReference;
                    $(".step3-cliam-reference", ".claim-step3-area").text(claimReference);
                    $(".claim-step3-area").removeClass("d-none")
                    $(".claim-step2-area").addClass("d-none");
                    
                    //초기화
                    redemption.resetClaim();
                    $("input[name='initFlag']", ".GPC0156").val("Y");
                    
                    redemption.ctrlScroll();
                    $(".GPC0156").trigger("ajaxLoadEnd");
                },
                error: function(error){
                    console.log("error:", error);
                    $(".GPC0156").trigger("ajaxLoadEnd");
                }
            });
        },
        // LGEUK-1045 End
        mailMoveToTrack : function() {
            var winW        = $(window).width();
            
            if (winW > 768) {
                $(".btn-tab-my", ".GPC0156").trigger("click");
                redemption.mailFlag = null;
            }
        },
        getParameterByName : function(name) {
            name        = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
            var regex   = new RegExp("[\\?&]" + name + "=([^&#]*)"),
                results = regex.exec(location.search);
            return results == null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
        }
        , setBtnEvent : function() {
            $(".GPC0156, #modal-redemption-edit-personal, #modal-redemption-edit-reward, #modal-redemption-edit-purchase").on({
                "ajaxLoadBefore" : function(e) {
                    e.stopPropagation();
                    $(this).append("<div class='loading-circle'><div class='lds-dual-ring'></div></div>");
                }
                , "ajaxLoadEnd" : function(e) {
                    e.stopPropagation();
                    $(this).find(".loading-circle").remove();
                }
            });
            
            $(".btn-tab", ".trans-tab").off("click").on("click", function(e) {
                e.preventDefault();
                var trans_tab   = $(".trans-tab", ".GPC0156").find(".tabs-type-liner");
                var initFlag    = $("input[name='initFlag']", ".GPC0156").val();
                
                $(".btn-tab", trans_tab).removeClass("active");
                $(this).addClass("active");
                
                if ($(this).hasClass("btn-tab-claim") && initFlag == "Y") {
                    $(".claim-step1-area").removeClass("d-none");
                    $(".claim-step2-area").addClass("d-none");
                    $(".claim-step3-area").addClass("d-none");
                    
                    $("input[name='initFlag']", ".GPC0156").val("N");
                } else if ($(this).hasClass("btn-tab-my")) {
                    $("input", "#mYClaim").val("");
                    $(".track-my-confirm", "#mYClaim").removeClass("d-none");
                    $(".track-my-info", "#mYClaim").addClass("d-none");
                } else if ($(this).hasClass("btn-tab-condition")) {
                    $(".btn-redemption-terms", "#terms").eq(0).trigger("click");
                }
                
                var target   = $(this).attr("href");
                
                $(".redemption-tab-area", ".GPC0156").removeClass("active");
                $(target).addClass("active");
                
                redemption.ctrlScroll();
            });
            
            $(".btn-claim-now", ".GPC0156").off("click").on("click", function(e) {
                e.preventDefault();
                
                var winW        = $(window).width();
                var initFlag    = $("input[name='initFlag']", ".GPC0156").val();
                
                if ($(this).hasClass("btn-tab-claim") && initFlag == "Y") {
                    $(".claim-step1-area").removeClass("d-none");
                    $(".claim-step2-area").addClass("d-none");
                    $(".claim-step3-area").addClass("d-none");
                    
                    $("input[name='initFlag']", ".GPC0156").val("N");
                }
                
                if (winW <= 768) {
                    var mobileLi    = $(".trans-tab", ".GPC0156").find(".tabs-type-liner").find("li");
                    
                    mobileLi.each(function(i) {
                        if (i == 1) {
                            $(".trans-tab", ".GPC0156").find("ul").slick("slickGoTo", i);
                        }
                    });
                } else {
                    $(".btn-tab-claim", ".GPC0156").trigger("click");
                }
            });
            
            $(".btn-my-claim", ".claim-step3-area").off("click").on("click", function(e) {
                e.preventDefault();
                
                var winW        = $(window).width();
                
                if (winW <= 768) {
                    var mobileLi    = $(".trans-tab", ".GPC0156").find(".tabs-type-liner").find("li");
                    
                    mobileLi.each(function(i) {
                        var tabA    = $(this).find("a");
                        
                        if (tabA.hasClass("btn-tab-my")) {
                            $(".trans-tab", ".GPC0156").find("ul").slick("slickGoTo", i);
                        }
                    });
                } else {
                    $(".btn-tab-my", ".GPC0156").trigger("click");
                }
            });
            
            $(".btn-readmore", ".GPC0156").off("click").on("click", function(e) {
                e.preventDefault();
                
                var targetClass = $(this).data("target");
                var winW = $(window).width();
                
                if (winW <= 768) {
                    var mobileLi    = $(".trans-tab").find(".tabs-type-liner").find("li");
                    var liLength    = mobileLi.length;
                    
                    mobileLi.each(function(i) {
                        if (liLength == 4) {
                            if (i == 3) {
                                $(".trans-tab ul").slick("slickGoTo", i);
                            }
                        } else {
                            if (i == 2) {
                                $(".trans-tab ul").slick("slickGoTo", i);
                            }
                        }
                    });
                } else {
                    $(".btn-tab-condition", ".GPC0156").trigger("click");
                }
                
                $(".btn-redemption-terms", "#terms").each(function() {
                    if ($(this).hasClass(targetClass)) {
                        $(this).trigger("click");
                    }
                });
            });
            
            $(".btn-step1-next", ".GPC0156").off("click").on("click", function(e) {
                e.preventDefault();
                
                $("select", "#claimStep1Form").attr("disabled", false);
                
                if ($("#claimStep1Form", ".GPC0156").checkValidation()) {
                    
                    $(".claim-step1-area").addClass("d-none")
                    $(".claim-step2-area").removeClass("d-none");
                    
                    redemption.ctrlScroll();
                } else {
                    $("select", "#claimStep1Form").each(function() {
                        if ($(this).val() == "") {
                            $(this).attr("disabled", true);
                        }
                    });
                }
            });
            
            $(".btn-step2-prev", ".GPC0156").off("click").on("click", function(e) {
                e.preventDefault();
                
                $(".claim-step1-area").removeClass("d-none")
                $(".claim-step2-area").addClass("d-none");
                
                redemption.ctrlScroll();
            });
            
            // LGEUK-1045 Start
            $(".btn-step2-submit", ".GPC0156").off("click").on("click", function(e) {
                e.preventDefault();

                const rewardCashBackFlag = redemption.rewardCashBackFlag;
                const chosenCashBack = $("input[data-reward-name='Cashback Type']").is(":checked") ? true : false;
                const readySubmit = rewardCashBackFlag ? redemption.rewardCashBackArea.checkValidation() : true;

                if(readySubmit){
                    if(rewardCashBackFlag && chosenCashBack) redemption.rewardCashBackModal.modal('show');
                    else redemption.claimNowSubmit();
                }
                else redemption.rewardCashBackArea.find('.field-block.error .error-msg span').show();
            });

            $(".btn-check-bank", "#modal_redemption_check_bank").off("click").on("click", function(e){
                e.preventDefault();
                $("#modal_redemption_check_bank").modal("hide");
                redemption.claimNowSubmit();
            });
            // LGEUK-1045 End 
            
            $(".btn-step3-submit", ".GPC0156").off("click").on("click", function(e) {
                e.preventDefault();
                
                var trans_tab   = $(".trans-tab", ".GPC0156").find(".tabs-type-liner");
                
                $(".btn-tab", trans_tab).each(function() {
                    if ($(this).hasClass("btn-tab-how")) {
                        $(".btn-tab-how", trans_tab).trigger("click");
                        return false;
                    } else if ($(this).hasClass("btn-tab-my")) {
                        $(".btn-tab-my", trans_tab).trigger("click");
                        return false;
                    } else {
                        return true;
                    }
                });
            });
            
            // LGEUK-1045 Start
            $(document).on("change", ".GPC0156 select[name='categoryId']", function(e){
                e.preventDefault();
                
                const useProductSubCategory = redemption.useProductSubCategory;

                let closestDiv      = $(this).closest(".redemption-model-list"),
                    value           = $(this).val(),
                    subCategoryId   = "subCategoryId";

                if(!useProductSubCategory)
                    subCategoryId   = null;
                
                redemption.categoryCtrl(closestDiv, value, subCategoryId, "modelId", useProductSubCategory);
            });
            // LGEUK-1045 End
            
            $(document).on("change", ".GPC0156 select[name='subCategoryId']", function(e){ // LGEITF-1003
                e.preventDefault();
                
                var closestDiv          = $(this).closest(".list"); // LGEITF-1003
                var value               = $(this).val();
                
                redemption.subCategoryCtrl(closestDiv, value, "categoryId", "modelId");
            });

            // LGEUK-1045 Start
            // add product row (Claim Now : step 1 / Track My Claim : edit Purchase Details modal)
            $(document).on("click", ".list.has-btn .btn-add-row, .option-list [data-name='btn-add-row']", function(e){
                e.preventDefault();
              
                let isButtonBlock     = $(this).is(".btn.btn-block"),
                    productRowArea    = !isButtonBlock ? $(this).closest(".list") : $(this).prev(".list"), // LGEITF-1003
                    addTargetBottom   = !isButtonBlock ? productRowArea.closest(".option-list").find(".btn.btn-block") : $(this), // LGEITF-988
                    isEditModal       = productRowArea.is(".customer-model-list"),
                    productRowClone   = isEditModal ? redemption.editCustomerProductRowClone : redemption.editProductRowClone;

                if(!$(this).is(".is-deleted")){ // add button
                    // LGEITF-988 Start :: add, del button switch 로직 삭제 + add row order target 공통화
                    addTargetBottom.before(productRowClone);
                    runChosen();
                    // LGEITF-988 End
                    chosenScrollInit(); // LGCOMUK-59
                }
                else{ // delete button
                    // edit modal 창에서 모델 삭제 시 기등록된 모델 삭제할 경우
                    if(isEditModal){
                        const deleteOrderNo                 = $("input[name='orderNo']", productRowArea).val()
                        if(deleteOrderNo != ""){
                            let customerDeleteModel         = {};
                            customerDeleteModel.localeCode  = $("html").data("countrycode").toUpperCase();
                            customerDeleteModel.redemptionId= $("input[name='redemptionId']", ".GPC0156").val();
                            customerDeleteModel.customerId  = $("input[name='customerId']", ".GPC0156").val();
                            customerDeleteModel.orderNo     = deleteOrderNo;
                            
                            redemption.customerDeleteModels.push(customerDeleteModel);
                        }
                    }
                    productRowArea.remove();
                }
              
                let modelListClass  = isEditModal ? ".customer-model-list" : ".redemption-model-list",
                    currentArea     = isEditModal ? "#modal-redemption-edit-purchase" : ".claim-step1-area";

                redemption.ctrlDynamicFile(modelListClass, currentArea);
            });

            $(document).on("change", "select[name='editModelId'], input[name='editSerialNumber']", ".has-btn.customer-model-list", function(e){
                $(this).checkValidation()
            });
            // LGEUK-1045 End
            
            $(document).on("click", ".receipt-add-btn", ".receipt-file-area", function(e){ // LGEUK-1041
                e.preventDefault();
                
                var receiptClone    = redemption.receiptClone.clone(true);
                var receiptArea     = $(".receipt-clone-area", ".receipt-file-area");
                
                if (!redemption.fileMaxLengthCheck(receiptArea, "receipt")) {
                    return;
                }
                
                receiptClone.find(".delivery-part").removeClass("available");
                receiptClone.find(".delivery-part").removeClass("attached");
                receiptClone.find(".add-next").removeClass("active").next(".delete-this").addClass("active");
                
                $(".receipt-file-area").append(receiptClone);
                
                receiptArea         = $(".receipt-clone-area", ".receipt-file-area");
                
                redemption.fileMaxLengthCheck(receiptArea, "receipt");
                bindFileUpload(receiptArea.last().find(".delivery-part")); // common.js bindFileUpload
            });
            
            $(document).on("click", ".receipt-delete-btn", ".receipt-file-area", function(e){ // LGEUK-1041
                e.preventDefault();
                
                var receiptClone    = redemption.receiptClone.clone(true);
                var receiptArea     = null;
                
                $(this).closest("div.receipt-clone-area").remove();
                
                receiptArea         = $(".receipt-clone-area", ".receipt-file-area");
                
                redemption.fileAttrUpdate(receiptArea, receiptClone);
                redemption.fileMaxLengthCheck(receiptArea, "receipt");
            });
            
            $(document).on("click", ".serial-add-btn", ".serial-file-area", function(e){ // LGEUK-1041
                e.preventDefault();
                
                var serialClone = redemption.serialClone.clone(true);
                var serialArea  = $(".serial-clone-area", ".serial-file-area");
                
                if (!redemption.fileMaxLengthCheck(serialArea, "serial")) {
                    return;
                }
                
                serialClone.find(".delivery-part").removeClass("available");
                serialClone.find(".delivery-part").removeClass("attached");
                serialClone.find(".add-next").removeClass("active").next(".delete-this").addClass("active");
                
                $(".serial-file-area").append(serialClone);
                
                serialArea      = $(".serial-clone-area", ".serial-file-area");
                
                redemption.fileAttrUpdate(serialArea, serialClone);
                redemption.fileMaxLengthCheck(serialArea, "serial");
                bindFileUpload(serialArea.last().find(".delivery-part")); // common.js bindFileUpload
            });
            
            $(document).on("click", ".serial-delete-btn", ".serial-file-area", function(e){ // LGEUK-1041
                e.preventDefault();
                
                var serialClone = redemption.serialClone.clone(true);
                var serialArea  = null;
                
                $(this).closest("div.serial-clone-area").remove();
                
                serialArea      = $(".serial-clone-area", ".serial-file-area");
                
                redemption.fileAttrUpdate(serialArea, serialClone);
                redemption.fileMaxLengthCheck(serialArea, "serial");
            });
            
            $("input[type='file']", "#claimStep1Form").off("change").on("change", function(e) {
                e.preventDefault();
                $(this).checkValidation(); // form-validation.js checkValidation
            });

            // LGEUK-1045 Start
            // cash back type - input bank account
            $("input[type='text'], input[type='tel']", ".choice-box[data-reward-cash='Y']").off("click").on("click", function(e) {
                $(this).closest(".choice-box[data-reward-cash='Y']").find("input[name='redemptionReward']").prop("checked", true);
            });
            // LGEUK-1045 End
            
            $(".btn-track-my", "#mYClaim").off("click").on("click", function(e) {
                e.preventDefault();
                var url             = $("input[name='redemptionTrackMyInfoUrl']", ".GPC0156").val();
                var emailAddress    = $("input[name='trackEmailAddress']", "#mYClaim").val();
                var claimReference  = $("input[name='claimReference']", "#mYClaim").val();
                var params          = {};
                
                params.redemptionId     = $("input[name='redemptionId']", ".GPC0156").val();
                params.emailAddress     = emailAddress;
                params.claimReference   = claimReference;
                
                $(".GPC0156").trigger("ajaxLoadBefore");
                
                if ($("#trackMyForm", ".GPC0156").checkValidation()) {
                    ajax.noCacheCall(url, xssfilter(params), 'json', function (d) { // LGEUK-1045
                        var data                        = d.data[0];
                        redemption.customerInfo         = data.customerInfo;
                        redemption.customerModelList    = data.customerModelList;
                        redemption.customerFileList     = data.customerFileList;
                        
                        if (data.confirmFlag == "N") {
                            $("#not_track_my_claim").modal("show");
                        } else {
                            redemption.trackMyClaimSetting(); // LGEUK-1045, LGEITF-1003
                            
                            $(".track-my-confirm", "#mYClaim").addClass("d-none");
                            $(".track-my-info", "#mYClaim").removeClass("d-none");
                            
                            // LGCOMUK-177 start
                            var redemptionIngFlag = $("#mYClaim").data("redemption-ing-flag");
                           
                            if( redemptionIngFlag == "C" && redemption.customerInfo.approveCode == "01"){
                            	$(".btn-edit-purchase").addClass("d-none");
                            	$(".btn-edit-personal").addClass("d-none");
                            	$(".btn-edit-reward").addClass("d-none");
                            }else if( redemptionIngFlag == "C"){
                            	$(".btn-edit-purchase").removeClass("d-none");
                            	$(".btn-edit-personal").removeClass("d-none");
                            	$(".btn-edit-reward").removeClass("d-none");
                            }
                            // LGCOMUK-177 end
                        }
                        
                        $(".GPC0156").trigger("ajaxLoadEnd");
                        
                    }, 'post');
                } else {
                        $(".GPC0156").trigger("ajaxLoadEnd");
                }
            });
            
            $(".btn-track-my-confirm", "#mYClaim").off("click").on("click", function(e) {
                e.preventDefault();
                
                $("input[name='customerId']", ".GPC0156").val("");
                $("input", "#mYClaim").val("");
                $(".track-my-confirm", "#mYClaim").removeClass("d-none");
                $(".track-my-info", "#mYClaim").addClass("d-none");
                
                redemption.ctrlScroll();
            });
            
            $(".btn-edit-personal", "#mYClaim").off("click").on("click", function(e) {
                e.preventDefault();
                
                redemption.trackMyClaimSetting();
                $("#modal-redemption-edit-personal").modal("show");
            });
            
            $(".btn-personal-details", "#modal-redemption-edit-personal").off("click").on("click", function(e) {
                e.preventDefault();
                
                var url                 = $("input[name='trackMyInfoUpdateUrl']", ".GPC0156").val();
                var formData            = new FormData();
                var params              = {};
                var flag                = "personal";
                
                params.redemptionId     = $("input[name='redemptionId']", ".GPC0156").val();
                params.customerId       = $("input[name='customerId']", ".GPC0156").val();
                params.title            = $("select[name='editClaimTitle']", "#modal-redemption-edit-personal").val();
                params.firstName        = $("input[name='editClaimFirstName']", "#modal-redemption-edit-personal").val();
                params.lastName         = $("input[name='editClaimLastName']", "#modal-redemption-edit-personal").val();
                params.emailAddress     = $("input[name='editClaimEmailAddress']", "#modal-redemption-edit-personal").val();
                params.mobilePhone      = $("input[name='editClaimMobilePhone']", "#modal-redemption-edit-personal").val();
                params.telephone        = $("input[name='editClaimTelephone']", "#modal-redemption-edit-personal").val();
                params.address          = $("input[name='editClaimAddress']", "#modal-redemption-edit-personal").val();
                params.updateFlag       = flag;
                
                formData.append("params", JSON.stringify(params));
                
                if ($("#modal-redemption-edit-personal").checkValidation()) {
                    redemption.updateTrackMyInfo(formData, url, flag);
                }
            });
            
            $(".btn-edit-reward", "#mYClaim").off("click").on("click", function(e) {
                e.preventDefault();
                
                redemption.trackMyClaimSetting();
                $("#modal-redemption-edit-reward").modal("show");
            });
            
            $(".btn-reward-details", "#modal-redemption-edit-reward").off("click").on("click", function(e) {
                e.preventDefault();
                
                var url                 = $("input[name='trackMyInfoUpdateUrl']", ".GPC0156").val();
                var formData            = new FormData();
                var params              = {};
                var flag                = "reward";
                
                params.redemptionId     = $("input[name='redemptionId']", ".GPC0156").val();
                params.customerId       = $("input[name='customerId']", ".GPC0156").val();
                params.rewardType       = $("input[name='editRedemptionReward']:checked", "#modal-redemption-edit-reward").data("reward-type");
                params.rewardOrderNo    = Number($("input[name='editRedemptionReward']:checked", "#modal-redemption-edit-reward").data("reward-order-no"));
                params.emailAddress     = redemption.customerInfo.emailAddress;
                params.updateFlag       = flag;
                
                formData.append("params", JSON.stringify(params));
                
                redemption.updateTrackMyInfo(formData, url, flag);
            });
            
            $(".btn-edit-purchase", "#mYClaim").off("click").on("click", function(e) {
                e.preventDefault();
                redemption.trackMyClaimEditPurchase(); // LGEITF-1003
            });
            
            // LGEUK-1045 Start
            $(document).on("change", "#modal-redemption-edit-purchase select[name='editCategoryId']", function(e){
                e.preventDefault();
                
                const useProductSubCategory = redemption.useProductSubCategory;

                let closestDiv          = $(this).closest(".customer-model-list"),
                    value               = $(this).val(),
                    editSubCategoryId   = "editSubCategoryId";

                if(!useProductSubCategory)
                    editSubCategoryId   = null;
                
                redemption.categoryCtrl(closestDiv, value, editSubCategoryId, "editModelId", useProductSubCategory);
            });
            // LGEUK-1045 End
            
            $(document).on("change", "#modal-redemption-edit-purchase select[name='editSubCategoryId']", function(e){ // LGEITF-1003
                e.preventDefault();
                
                var closestDiv          = $(this).closest(".list"); // LGEITF-1003
                var value               = $(this).val();
                
                redemption.subCategoryCtrl(closestDiv, value, "editCategoryId", "editModelId");
            });
            
            $(".btn-purchase-details", "#modal-redemption-edit-purchase").off("click").on("click", function(e) {
                e.preventDefault();
                
                var url                 = $("input[name='trackMyInfoUpdateUrl']", ".GPC0156").val();
                var formData            = new FormData();
                var flag                = "file";
                var params              = {};
                var customerModels      = [];
                var receiptFileList     = [];
                var serialFileList      = [];
                var receiptFileUpload   = $(".edit-receipt-file-upload", "#modal-redemption-edit-purchase");
                var serialFileUpload    = $(".edit-serial-file-upload", "#modal-redemption-edit-purchase");
                
                params.redemptionId     = $("input[name='redemptionId']", ".GPC0156").val();
                params.customerId       = $("input[name='customerId']", ".GPC0156").val();
                params.purchasePlace    = $("input[name='editPurchasePlace']", "#modal-redemption-edit-purchase").val();
                params.purchaseDate     = $("input[name='editPurchaseDate']", "#modal-redemption-edit-purchase").val();
                params.updateFlag       = flag;
                params.emailAddress     = redemption.customerInfo.emailAddress;
                
                $(".customer-model-list", "#modal-redemption-edit-purchase").each(function() {
                    var customerModel   = {};
                    customerModel.categoryId    = $("select[name='editCategoryId']", $(this)).val();
                    customerModel.subCategoryId = $("select[name='editSubCategoryId']", $(this)).val();
                    customerModel.modelId       = $("select[name='editModelId'] option:selected", $(this)).val();
                    customerModel.modelName     = $("select[name='editModelId'] option:selected", $(this)).text();
                    customerModel.serialNumber  = $("input[name='editSerialNumber']", $(this)).val();
                    customerModel.purchasedPrice  = $("input[name='editPurchasedPrice']", $(this)).val(); // LGCOMUK-41
                    customerModel.orderNo       = Number($("input[name='orderNo']", $(this)).val());
                    
                    customerModels.push(customerModel);
                });
                
                for (var i = 0; i < receiptFileUpload.length; i++) {
                    if (receiptFileUpload[i].files.length > 0) {
                        for (var j = 0; j < receiptFileUpload[i].files.length; j++) {
                            formData.append('receiptFiles', $('.edit-receipt-file-upload')[i].files[j]);
                        }
                    }
                }
                
                for (var i = 0; i < serialFileUpload.length; i++) {
                    if (serialFileUpload[i].files.length > 0) {
                        for (var j = 0; j < serialFileUpload[i].files.length; j++) {
                            formData.append('serialFiles', $('.edit-serial-file-upload')[i].files[j]);
                        }
                    }
                }
                
                $(".edit-receipt-clone-area", "#modal-redemption-edit-purchase").each(function() {
                    var receiptFile = {};
                    receiptFile.orderNo         = Number($("input[name='orderNo']", $(this)).val());
                    receiptFile.filePathAddr    = $("input[name='filePathAddr']", $(this)).val();
                    receiptFile.fileName        = $("input[name='fileName']", $(this)).val();
                    receiptFile.newFileName     = $("input[name='newFileName']", $(this)).val();
                    receiptFile.fileFlag        = $("input[name='fileFlag']", $(this)).val();
                    receiptFileList.push(receiptFile);
                });
                
                $(".edit-serial-clone-area", "#modal-redemption-edit-purchase").each(function() {
                    var serialFile = {};
                    serialFile.orderNo         = Number($("input[name='orderNo']", $(this)).val());
                    serialFile.filePathAddr    = $("input[name='filePathAddr']", $(this)).val();
                    serialFile.fileName        = $("input[name='fileName']", $(this)).val();
                    serialFile.newFileName     = $("input[name='newFileName']", $(this)).val();
                    serialFile.fileFlag        = $("input[name='fileFlag']", $(this)).val();
                    serialFileList.push(serialFile);
                });
                
                params.customerModels       = customerModels;
                params.customerDeleteModels = redemption.customerDeleteModels; // LGEUK-1045
                params.receiptFileList      = receiptFileList;
                params.serialFileList       = serialFileList;
                
                formData.append("params", JSON.stringify(params));
                
                $(".file-name-expose", "#modal-redemption-edit-purchase").each(function() {
                    var closestDiv  = $(this).closest("div.field-block");
                    var fileFlag    = $("input[name='fileFlag']", closestDiv).val();
                    
                    if ($(this).val() != ""  && fileFlag == "EXIST") {
                        $("input[type='file']", closestDiv).removeAttr("required");
                        $("input[type='file']", closestDiv).prop("disabled", true);
                    } else {
                        $("input[type='file']", closestDiv).prop("required", "required");
                        $("input[type='file']", closestDiv).prop("disabled", false);
                    }
                });
                
                $("select", "#modal-redemption-edit-purchase").attr("disabled", false);
                
                if ($("#modal-redemption-edit-purchase").checkValidation()) {
                    redemption.updateTrackMyInfo(formData, url, flag);
                } else {
                    $("input[type='file']", "#modal-redemption-edit-purchase").prop("required", "required");
                    $("input[type='file']", "#modal-redemption-edit-purchase").prop("disabled", false);
                    
                    $("select", "#modal-redemption-edit-purchase").each(function() {
                        if ($(this).val() == "") {
                            $(this).attr("disabled", true);
                        }
                    });
                }
            });
            
            $(document).on("click", ".edit-receipt-add-btn", ".edit-receipt-file-area", function(e){ // LGEUK-1041
                e.preventDefault();
                
                var receiptClone    = redemption.editReceiptClone.clone(true);
                var receiptArea     = $(".edit-receipt-clone-area", ".edit-receipt-file-area");
                
                if (!redemption.fileModifyMaxLengthCheck(receiptArea, "edit-receipt")) {
                    return;
                }
                
                receiptClone.find(".delivery-part").removeClass("available");
                receiptClone.find(".delivery-part").removeClass("attached");
                receiptClone.find(".add-next").removeClass("active").next(".delete-this").addClass("active");
                
                $(".edit-receipt-file-area").append(receiptClone);
                
                receiptArea         = $(".edit-receipt-clone-area", ".edit-receipt-file-area");
                
                redemption.fileAttrUpdate(receiptArea, receiptClone);
                redemption.fileModifyMaxLengthCheck(receiptArea, "edit-receipt");
                bindFileUpload(receiptArea.last().find(".delivery-part")); // common.js bindFileUpload
            });
            
            $(document).on("click", ".edit-receipt-delete-btn", ".edit-receipt-file-area", function(e){ // LGEUK-1041
                e.preventDefault();
                
                var receiptClone    = redemption.editReceiptClone.clone(true);
                var receiptArea     = null;
                var area        = $(this).closest("div.edit-receipt-clone-area");
                var fileFlag    = $("input[name='fileFlag']", area).val();
                
                if (fileFlag == "NEW") {
                    area.remove();
                } else {
                   area.addClass("d-none");
                    $("input[name='fileFlag']", area).val("DEL");
                }
                
                receiptArea         = $(".edit-receipt-clone-area", ".edit-receipt-file-area");
                
                redemption.fileAttrUpdate(receiptArea, receiptClone);
                redemption.fileModifyMaxLengthCheck(receiptArea, "edit-receipt");
            });
            
            $(document).on("click", ".edit-serial-add-btn", ".edit-serial-file-area", function(e){ // LGEUK-1041
                e.preventDefault();
                
                var serialClone = redemption.editSerialClone.clone(true);
                var serialArea  = $(".edit-serial-clone-area", ".edit-serial-file-area");
                
                if (!redemption.fileModifyMaxLengthCheck(serialArea, "edit-serial")) {
                    return;
                }
                
                serialClone.find(".delivery-part").removeClass("available");
                serialClone.find(".delivery-part").removeClass("attached");
                serialClone.find(".add-next").removeClass("active").next(".delete-this").addClass("active");
                
                $(".edit-serial-file-area").append(serialClone);
                
                serialArea      = $(".edit-serial-clone-area", ".edit-serial-file-area");
                
                redemption.fileAttrUpdate(serialArea, serialClone);
                redemption.fileModifyMaxLengthCheck(serialArea, "edit-serial");
                bindFileUpload(serialArea.last().find(".delivery-part")); // common.js bindFileUpload
            });
            
            $(document).on("click", ".edit-serial-delete-btn", ".edit-serial-file-area", function(e){ // LGEUK-1041
                e.preventDefault();
                
                var serialClone = redemption.editSerialClone.clone(true);
                var serialArea  = null;
                var area        = $(this).closest("div.edit-serial-clone-area");
                var fileFlag    = $("input[name='fileFlag']", area).val();
                
                if (fileFlag == "NEW") {
                    area.remove();
                } else {
                    area.addClass("d-none");
                    $("input[name='fileFlag']", area).val("DEL");
                }
                
                serialArea      = $(".edit-serial-clone-area", ".edit-serial-file-area");
                
                redemption.fileAttrUpdate(serialArea, serialClone);
                redemption.fileModifyMaxLengthCheck(serialArea, "edit-serial");
            });
            
            $("input[type='file']", "#modal-redemption-edit-purchase").off("change").on("change", function(e) {
                e.preventDefault();
                var closestDiv  = $(this).closest("div.field-block");
                var fileFlag    = $("input[name='fileFlag']", closestDiv).val();
                
                if ($(this).checkValidation()) { // form-validation.js checkValidation
                
                    if (fileFlag == "EXIST" || fileFlag == "NOTEXIST" || fileFlag == "NOTMOD") {
                        $("input[name='fileFlag']", closestDiv).val("MOD");
                    } else if (fileFlag == "NOTNEW") {
                        $("input[name='fileFlag']", closestDiv).val("NEW");
                    }
                } else {
                    if (fileFlag == "EXIST") {
                        $("input[name='fileFlag']", closestDiv).val("NOTEXIST");
                    } else if (fileFlag == "MOD") {
                        $("input[name='fileFlag']", closestDiv).val("NOTMOD");
                    } else if (fileFlag == "NEW") {
                        $("input[name='fileFlag']", closestDiv).val("NOTNEW");
                    }
                }
            });
            
            $(".btb-history-back", ".GPC0156").off("click").on("click", function(e) {
                e.preventDefault();
                
                history.back();
            });
            
            $("#claimReference", "#mYClaim").off("keypress").on("keypress", function() {
                
                if($(this).val().length == 3 || $(this).val().length == 7) {
                    $(this).val($(this).val() + "-");
                }    
            });
        },
        updateTrackMyInfo : function(formData, url, flag) {
            var objId = "";
            
            if (flag == "personal") {
                objId = "#modal-redemption-edit-personal";
            } else if (flag == "reward") {
                objId = "#modal-redemption-edit-reward";
            } else {
                objId = "#modal-redemption-edit-purchase";
            }
            
            $(objId).trigger("ajaxLoadBefore");
            
            $.ajax({
                    type:"POST",
                    url: url,
                    processData: false,
                    contentType: false,
                    enctype : 'multipart/form-data',
                    data: formData,
                    success: function(d) {
                        var data    = d.data[0];
                        
                        redemption.customerInfo = data.customerInfo;
                        
                        if (flag == "file") {
                            redemption.customerModelList    = data.customerModelList;
                            redemption.customerFileList     = data.customerFileList;
                        }
                        
                        $(objId).trigger("ajaxLoadEnd");
                        $(objId).modal("hide");
                        
                        redemption.trackMyClaimSetting(); // LGEUK-1045, LGEITF-1003
                        redemption.ctrlScroll();
                    },
                    error: function(error) {
                        console.log("error:", error);
                    }
                });
        },
        // LGEUK-1045, LGEITF-1003 Start
        // edit modal show 시마다 modal content만 리셋하기 위해 trackMyClaimSetting() 내 있던 코드 별도 함수화
        trackMyClaimEditPurchase : function() {
            const customerInfo      = redemption.customerInfo,
                  customerModelList = redemption.customerModelList,
                  customerFileList  = redemption.customerFileList,
                  EDIT_PURCHASE_ID  = "#modal-redemption-edit-purchase",
                  addBtnBlock       = $("[data-name='btn-add-row']", EDIT_PURCHASE_ID);

            // 등록된 모델 갯수만큼 add Product row 마크업 추가
            addBtnBlock.closest(".option-list").find(".customer-model-list").remove();

            for(var i=0; i<customerModelList.length; i++)
                addBtnBlock.before(redemption.editCustomerProductRowClone);
            
            runChosen();
            chosenScrollInit(); // LGCOMUK-59
            redemption.ctrlDynamicFile(".customer-model-list", EDIT_PURCHASE_ID);

            $(".customer-model-list", EDIT_PURCHASE_ID).each(function(i) {
                const useProductSubCategory = redemption.useProductSubCategory;
                
                let modelInfo       = customerModelList[i],
                    closestDiv      = $(this),
                    value           = modelInfo.categoryId,
                    editSubCategoryId   = useProductSubCategory ? "editSubCategoryId" : null;
            
                $("select[name='editCategoryId']", $(this)).val(modelInfo.categoryId);
                redemption.categoryCtrl(closestDiv, value, editSubCategoryId, "editModelId", useProductSubCategory);

                if(useProductSubCategory){
                    $("select[name='editSubCategoryId']", $(this)).val(modelInfo.subCategoryId);
                    $("select[name='editSubCategoryId']", $(this)).trigger('chosen:updated');
                    redemption.subCategoryCtrl(closestDiv, modelInfo.subCategoryId, "editCategoryId", "editModelId");
                };
                if(i === 0) // set add/delete btn
                    $(".btn-add-row", $(this)).removeClass('is-deleted').attr('aria-label','add');

                $("select[name='editModelId']", $(this)).val(modelInfo.modelId);
                $("select[name='editModelId']", $(this)).trigger('chosen:updated');
                $("input[name='editSerialNumber']", $(this)).val(modelInfo.serialNumber);
                $("input[name='editPurchasedPrice']", $(this)).val(modelInfo.purchasedPrice); // LGCOMUK-41
                $("input[name='orderNo']", $(this)).val(modelInfo.orderNo);
            });
            
            $("input[name='editPurchasePlace']", EDIT_PURCHASE_ID).val(customerInfo.purchasePlace);
            $("input[name='editPurchaseDate']", EDIT_PURCHASE_ID).val(customerInfo.purchaseDate);
            
            if (customerFileList != null && customerFileList.length > 0) {
                $(".edit-receipt-clone-area", EDIT_PURCHASE_ID).remove();
                $(".edit-serial-clone-area", EDIT_PURCHASE_ID).remove();
                
                var receiptList = [];
                var serialList  = [];
                
                for (var i=0; i<customerFileList.length; i++) {
                    var fileInfo    = customerFileList[i];
                    
                    if (fileInfo.fileType == "R") {
                        receiptList.push(fileInfo);
                    } else {
                        serialList.push(fileInfo);
                    }
                }
                
                for (var i=0; i<receiptList.length; i++) {
                    var receiptInfo  = receiptList[i];
                    var receiptClone = redemption.editReceiptClone.clone(true);
                    var receiptArea  = null;
                    var deleteTxt    = receiptClone.find(".file-name-expose").data("delete-title");
                    
                    receiptClone.find(".delivery-part").addClass("available");
                    receiptClone.find(".delivery-part").addClass("attached");
                    
                    if (i != 0) {
                        receiptClone.find(".add-next").removeClass("active").next(".delete-this").addClass("active");
                    }
                    
                    receiptClone.find(".file-name-expose").val(receiptInfo.fileName);
                    receiptClone.find(".file-name-expose").wrap('<div class="file-name-expose"></div>');
                    receiptClone.find("div.file-name-expose").append('<a class="delete" href="#"><span class="icon"></span><span class="sr-only">' + xssfilter(deleteTxt) + '</span></a>');
                    receiptClone.find("input[name='orderNo']").val(receiptInfo.orderNo);
                    receiptClone.find("input[name='filePathAddr']").val(receiptInfo.filePathAddr);
                    receiptClone.find("input[name='fileName']").val(receiptInfo.fileName);
                    receiptClone.find("input[name='newFileName']").val(receiptInfo.newFileName);
                    receiptClone.find("input[name='fileFlag']").val("EXIST");
                    
                    $(".edit-receipt-file-area").append(receiptClone);
                    
                    receiptArea      = $(".edit-receipt-clone-area", ".edit-receipt-file-area");
                    
                    redemption.fileAttrUpdate(receiptArea, receiptClone);
                    redemption.fileModifyMaxLengthCheck(receiptArea, "edit-receipt");
                    bindFileUpload(receiptArea.last().find(".delivery-part"));
                }
                
                for (var i=0; i<serialList.length; i++) {
                    var serialInfo  = serialList[i];
                    
                    var serialClone = redemption.editSerialClone.clone(true);
                    var serialArea  = null;
                    var deleteTxt   = serialClone.find(".file-name-expose").data("delete-title");
                    
                    serialClone.find(".delivery-part").addClass("available");
                    serialClone.find(".delivery-part").addClass("attached");
                    
                    if (i != 0) {
                        serialClone.find(".add-next").removeClass("active").next(".delete-this").addClass("active");
                    }
                    
                    serialClone.find(".file-name-expose").val(serialInfo.fileName);
                    serialClone.find(".file-name-expose").wrap('<div class="file-name-expose"></div>');
                    serialClone.find("div.file-name-expose").append('<a class="delete" href="#"><span class="icon"></span><span class="sr-only">' + xssfilter(deleteTxt) + '</span></a>');
                    serialClone.find("input[name='orderNo']").val(serialInfo.orderNo);
                    serialClone.find("input[name='filePathAddr']").val(serialInfo.filePathAddr);
                    serialClone.find("input[name='fileName']").val(serialInfo.fileName);
                    serialClone.find("input[name='newFileName']").val(serialInfo.newFileName);
                    serialClone.find("input[name='fileFlag']").val("EXIST");
                    
                    $(".edit-serial-file-area").append(serialClone);
                    
                    serialArea      = $(".edit-serial-clone-area", ".edit-serial-file-area");
                    
                    redemption.fileAttrUpdate(serialArea, serialClone);
                    redemption.fileModifyMaxLengthCheck(serialArea, "edit-serial");
                    bindFileUpload(serialArea.last().find(".delivery-part"));
                }
            }

            $("#modal-redemption-edit-purchase").modal("show");
        },
        // LGEUK-1045, LGEITF-1003 End
        trackMyClaimSetting : function() {
            var customerInfo        =   redemption.customerInfo;
            var customerModelList   =   redemption.customerModelList;
            var customerFileList    =   redemption.customerFileList;
            var modelInfoLi         = "";
            
            console.log(customerInfo);
            console.log(customerModelList);
            console.log(customerFileList);
            
            $("input[name='customerId']", ".GPC0156").val(customerInfo.customerId);
            $(".claim-reference-number", ".track-my-info").text(customerInfo.claimReference);
            
            // LGEUK-1045, LGEUK-1153, LGCOMUK-177 Start
            const claimStatusArea = $(".claim-status-cls", ".track-my-info");
            if(claimStatusArea.length){
                let claimStatus = null;
                switch(customerInfo.approveCode){
                    case "01":
                        claimStatus = '<span class="claim-status">'+claimStatusArea.data("msg-approve") + "</span>";
                        break;
                    case "02":
                        claimStatus = '<span class="claim-status">'+claimStatusArea.data("msg-reject") + "</span>" + customerInfo.reason;
                        break;
                    default: // Review or null
                        claimStatus = '<span class="claim-status">'+claimStatusArea.data("msg-review") + "</span>";
                        break;
                }
                claimStatusArea.html(claimStatus);
            }
            // LGEUK-1045, LGEUK-1153, LGCOMUK-177 End
            
            $(".my-invoice-number", ".track-my-info").text(customerInfo.invoiceNumber);
            $(".my-delivery-status", ".track-my-info").text(customerInfo.deliveryStatus);
            $(".my-delivery-date", ".track-my-info").text(customerInfo.deliveryDate);
            $(".my-courier", ".track-my-info").text(customerInfo.courier);
            
            //LGEUK-1132 Start
            if (customerInfo.deliveryFlag == "N") {
            //LGEUK-1132 End
                $(".track-your-shipment").addClass("d-none");
            } else {
                $(".track-your-shipment").removeClass("d-none");
            }
            
            for (var i=0; i<customerModelList.length; i++) {
                var modelInfo   = customerModelList[i];
                modelInfoLi    += "<li>" + modelInfo.categoryName + "</li>";
                modelInfoLi    += "<li>" + modelInfo.subCategoryName + "</li>";
                modelInfoLi    += "<li>" + modelInfo.modelName + "</li>";
            }
            
            $(".my-model-list", ".track-my-info").empty();
            $(".my-model-list", ".track-my-info").append(modelInfoLi);
            $(".my-purchase-place", ".track-my-info").text(customerInfo.purchasePlace);
            $(".my-purchase-date", ".track-my-info").text(customerInfo.purchaseDate);
            
            $(".my-name", ".track-my-info").text(customerInfo.customerName);
            $(".my-email", ".track-my-info").text(customerInfo.emailAddress);
            $(".my-mobile-phone", ".track-my-info").text(customerInfo.mobilePhone);
            $(".my-telephone", ".track-my-info").text(customerInfo.telephone);
            $(".my-address", ".track-my-info").text(customerInfo.address);
            
            if (customerInfo.rewardType == "03") {
                $(".my-reward-image-alt", ".track-my-info").addClass("d-none");
            } else {
                $(".my-reward-image-alt", ".track-my-info").removeClass("d-none");
                $(".my-reward-image-alt", ".track-my-info").attr("src", customerInfo.rewardImage);
                $(".my-reward-image-alt", ".track-my-info").attr("alt", customerInfo.rewardImageAlt);
            }
            
            $(".my-reward-name", ".track-my-info").text(customerInfo.rewardName);
            
            $("select[name='editClaimTitle']", "#modal-redemption-edit-personal").val(customerInfo.title);
            $("select", "#modal-redemption-edit-personal").trigger("chosen:updated");
            
            $("input[name='editClaimFirstName']", "#modal-redemption-edit-personal").val(customerInfo.firstName);
            $("input[name='editClaimLastName']", "#modal-redemption-edit-personal").val(customerInfo.lastName);
            $("input[name='editClaimEmailAddress']", "#modal-redemption-edit-personal").val(customerInfo.emailAddress);
            $("input[name='editClaimMobilePhone']", "#modal-redemption-edit-personal").val(customerInfo.mobilePhone);
            $("input[name='editClaimTelephone']", "#modal-redemption-edit-personal").val(customerInfo.telephone);
            $("input[name='editClaimAddress']", "#modal-redemption-edit-personal").val(customerInfo.address);
            
            $("input[name='editRedemptionReward']", "#modal-redemption-edit-reward").prop("checked", false);
            $("input[name='editRedemptionReward']", "#modal-redemption-edit-reward").each(function(i) {
                var rewardType      = $(this).data("reward-type");
                var rewardOrderNo   = Number($(this).data("reward-order-no"));
                
                if (rewardType == customerInfo.rewardType && rewardOrderNo == Number(customerInfo.rewardOrderNo)) {
                    $(this).prop("checked", true);
                }
            });
        },
        // LGEUK-1045 Start
        categoryCtrl : function(closestDiv, value, subCategoryId, modelId, useProductSubCategory) {
          const modelList         = redemption.modelList,
                useSubCategory    = useProductSubCategory && !!subCategoryId ? true : false;
                nextTarget        = useSubCategory ? subCategoryId : modelId;

          let defaultSubOption    = "<option value='' disabled selected>" + redemption.subCategoryMessage + "</option>",
              defaultModelOption  = "<option value='' disabled selected>" + redemption.modelNameMessage + "</option>",
              compareSubCategoryId= []; // LGEITF-999
          
          // reset
          if(useSubCategory){
            $("select[name='" + subCategoryId + "'] option", closestDiv).remove();
            $("select[name='" + subCategoryId + "']", closestDiv).append(defaultSubOption);
          }
          
          $("select[name='" + modelId + "'] option", closestDiv).remove();
          $("select[name='" + modelId + "']", closestDiv).append(defaultModelOption);
          $("select[name='" + modelId + "']", closestDiv).attr("disabled", true);

          // append data
          if(!!value){
            $("select[name='" + nextTarget + "']", closestDiv).attr("disabled", false).find("option:not(:first-child)").remove();
            
            if(useSubCategory){
              for (var i=0; i<modelList.length; i++) {
                let modelInfo = modelList[i],
                    option    = "";
                
                if (value == modelInfo.categoryId && !compareSubCategoryId.includes(modelInfo.subCategoryId) ) { // LGEITF-999
                  option      = $("<option value='" + modelInfo.subCategoryId + "'>" + modelInfo.subCategoryName + "</option>");
                  $("select[name='" + nextTarget + "']", closestDiv).append(option);
                  compareSubCategoryId.push(modelInfo.subCategoryId); // LGEITF-999
                }
              }
            }else{
              for(var i=0; i<modelList.length; i++){
                let modelInfo = modelList[i],
                    option    = "";
                
                if(value == modelInfo.categoryId){
                  option      = $("<option value='" + modelInfo.modelId + "'>" + modelInfo.modelName + "</option>");
                  $("select[name='" + nextTarget + "']", closestDiv).append(option);
                }
              }
            }
          }
          else
            $("select[name='" + subCategoryId + "']", closestDiv).attr("disabled", true);
          
          $("select", closestDiv).trigger('chosen:updated');
        },
        // LGEUK-1045 End
        subCategoryCtrl : function(closestDiv, value, categoryId, modelId) {
            var modelList           = redemption.modelList;
            var categoryValue       = $("select[name='" + categoryId + "']", closestDiv).val();
            var defaultModelOption  = "<option value='' disabled selected>" + redemption.modelNameMessage + "</option>";
            
            $("select[name='" + modelId + "'] option", closestDiv).remove();
            $("select[name='" + modelId + "']", closestDiv).append(defaultModelOption);
            
            if (value != null && value != "") {
                $("select[name='" + modelId + "']", closestDiv).attr("disabled", false).find("option:not(:first-child)").remove();
                
                for (var i=0; i<modelList.length; i++) {
                    var modelInfo   = modelList[i];
                    var option      = "";
                    
                    if (categoryValue == modelInfo.categoryId && value == modelInfo.subCategoryId) {
                        option      = $("<option value='" + modelInfo.modelId + "'>" + modelInfo.modelName + "</option>");
                    }
                    
                    $("select[name='" + modelId + "']", closestDiv).append(option);
                }
                
            }
            
            $("select[name='" + modelId + "']", closestDiv).trigger('chosen:updated');
        },
        resetClaim : function () {
            $("input[type='text'], input[type='email'], input[type='tel']", "#claimStep1Form").val("");
            
            $(".delete", ".GPC0156").trigger("click");
            
            $("input[type='checkbox']", "#claimStep1Form").prop("checked", false);
            
            $("select", "#claimStep1Form").val("");
            $("select[name='categoryId']", "#claimStep1Form").trigger("change");
            $("select", "#claimStep1Form").trigger('chosen:updated');
            
            $("input[name='redemptionReward']", ".GPC0156").prop("checked", false);
            $("input[name='redemptionReward']", ".GPC0156").eq(0).prop("checked", true);
            
            $(".receipt-clone-area").each(function(i) {
                if (i > 0) {
                    $(this).remove();
                }
            });
            
            $(".serial-clone-area").each(function(i) {
                if (i > 0) {
                    $(this).remove();
                }
            });
        },
        ctrlScroll : function () {
            var trans_tab   = $(".trans-tab", ".GPC0156").find(".tabs-type-liner");
            
            var trans_tab_Y = trans_tab.offset().top;
            var cookie_height = $('body').find(".cookie-eu-get-height").height();
            if (typeof(cookie_height) == 'undefined') cookie_height = 0;
            $('html, body').stop().animate({ scrollTop : trans_tab_Y-cookie_height}, 500);
        },
        // LGEUK-1041 Start
        ctrlDynamicFile : function (modelListClass, currentArea) {
            let modelLegnth     = $(modelListClass, currentArea).length,
                targetFileArea  = $(".fileupload-init", currentArea);

            // 초기 로딩 상태(add-btn : disabled)에서 모델 추가 시
            // Or 모델 추가로 인해 Max length 증가했을 시 파일 업로드 영역 add-btn 활성화
            targetFileArea.each(function(){
                if($(this).find("> .field-block").length < modelLegnth){
                    $(this).find(".add-next").attr("disabled", false);
                }
            });

            targetFileArea.data("multi-length", modelLegnth);
        },
        // LGEUK-1041 End
        fileMaxLengthCheck : function(area, name) {
            var maxLimitLength  = Number(area.closest("div." + name + "-file-area").data("multi-length"));
            var maxLength       = area.length;
            
            if (maxLimitLength == maxLength) {
                area.eq(0).find("." + name + "-add-btn").attr("disabled", true);
                return false;
            } else {
                area.eq(0).find("." + name + "-add-btn").attr("disabled", false);
                return true;
            }
        },
        fileModifyMaxLengthCheck : function(area, name) {
            var maxLimitLength  = Number(area.closest("div." + name + "-file-area").data("multi-length"));
            var maxLength       = 0;
            
            area.each(function() {
                if(!$(this).hasClass("d-none")) {
                    maxLength += 1;
                }
            });
            
            if (maxLimitLength == maxLength) {
                area.eq(0).find("." + name + "-add-btn").attr("disabled", true);
                return false;
            } else {
                area.eq(0).find("." + name + "-add-btn").attr("disabled", false);
                return true;
            }
        },
        fileAttrUpdate : function(area, clone) {
            var fileInputName       = clone.find("input[type='file']").attr("name");
            var fileInputId         = clone.find("input[type='file']").attr("id");
            
            var fileNameInputName   = clone.find("input.file-name-expose").attr("name");
            var fileNameInputId     = clone.find("input.file-name-expose").attr("id");
            
            area.each(function(i) {
                var index   = i + 1;
                
                $("input[type='file']", $(this)).attr({
                    "name"  : fileInputName + "_" + index
                    , "id"  : fileInputId + "_" + index
                }).next("label", $(this)).attr({
                    "for"   : fileInputId + "_" + index
                });
                
                $("input.file-name-expose", $(this)).attr({
                    "name"  : fileNameInputName + "_" + index
                    , "id"  : fileNameInputId + "_" + index
                });
            });
        },
        tab_ui : function(){
            $(window).on('load resize', function(){
                var winW = $(window).width();
                var trans_tab = $(".trans-tab").find(".tabs-type-liner");
                var delay = 500;
                var timer = null;
                const activePage = trans_tab.find('.active').parent('li').index();
                clearTimeout(timer);
                timer = setTimeout(function(){
                    if(winW <= 768){
                        trans_tab.addClass("init-slick");
                        trans_tab.find('ul').slick({
                            listStyle: false,
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            infinite: false,
                            initialSlide: activePage,
                            arrows : true,
                            dots: false
                        });
                    } else{
                        trans_tab.removeClass("init-slick");
                        if (trans_tab.find('ul').hasClass('slick-initialized')){
                            trans_tab.find('ul').slick('unslick')
                        } else{
                            return false
                        };
                    }
                    $('.trans-tab ul.slick-slider').on('init', function(){
                        $(this).find('.btn-tab').removeClass('active');
                        var target_slide = $(this).find('.slick-current').find('a').addClass("active").attr("href");
                        $(".redemption-tab-area").removeClass("active");
                        $(target_slide).addClass("active");
                        
                        var mobileLi    = $(".trans-tab", ".GPC0156").find(".tabs-type-liner").find("li");
                        
                        mobileLi.each(function(i) {
                            var tabA    = $(this).find("a");
                            
                            if (tabA.hasClass("btn-tab-my") && (redemption.mailFlag != null && redemption.mailFlag != "")) {
                                $(".trans-tab", ".GPC0156").find("ul").slick("slickGoTo", i);
                                redemption.mailFlag = null;
                            }
                        });
                    });
                    $('.trans-tab ul.slick-slider').on('afterChange', function(){
                        $(this).find('.btn-tab').removeClass('active');
                        var target_slide = $(this).find('.slick-current').find('a').addClass("active").attr("href");
                        $(".redemption-tab-area").removeClass("active");
                        $(target_slide).addClass("active");
                        
                        var initFlag    = $("input[name='initFlag']", ".GPC0156").val();
                        var mobileLi    = $(".trans-tab", ".GPC0156").find(".tabs-type-liner").find("li");
                        
                        mobileLi.each(function(i) {
                            var tabA    = $(this).find("a");
                            
                            if (tabA.hasClass("btn-tab-claim")  && initFlag == "Y") {
                                $(".claim-step1-area").removeClass("d-none");
                                $(".claim-step2-area").addClass("d-none");
                                $(".claim-step3-area").addClass("d-none");
                                
                                $("input[name='initFlag']", ".GPC0156").val("N");
                            } else if (tabA.hasClass("btn-tab-my")) {
                                $("input", "#mYClaim").val("");
                                $(".track-my-confirm", "#mYClaim").removeClass("d-none");
                                $(".track-my-info", "#mYClaim").addClass("d-none");
                            } else if (tabA.hasClass("btn-tab-condition")) {
                                $(".btn-redemption-terms", "#terms").eq(0).trigger("click");
                            }
                        });
                        
                        var trans_tab_Y = trans_tab.offset().top;
                        var cookie_height = $('body').find(".cookie-eu-get-height").height();
                        if (typeof(cookie_height) == 'undefined') cookie_height = 0;
                        $('html, body').stop().animate({ scrollTop : trans_tab_Y-cookie_height}, 500);
                    });
                }, delay);
            });
        },
        bg_load : function () {
            var howToClaim_bg = $(".howToClaim-top");
            $(window).on('load', function(){
                if($(window).width() > 768) {
                    howToClaim_bg.css("background-image","url("+howToClaim_bg.attr('data-wo')+")");
                } else {
                    howToClaim_bg.css("background-image","url("+howToClaim_bg.attr('data-mo')+")");
                }
            });
        },
        bg_resize : function () {
            var howToClaim_bg = $(".howToClaim-top");
            var checkMobile;
            if($(window).width() > 768) {
                checkMobile = false;
            } else {
                checkMobile = true;
            }
            
            $(window).on('resize', function(){
                if($(window).width() > 768) {
                    if(checkMobile) {
                        howToClaim_bg.css("background-image","url("+howToClaim_bg.attr('data-wo')+")");
                        checkMobile = false;
                    }
                } else {
                    if(!checkMobile) {
                        howToClaim_bg.css("background-image","url("+howToClaim_bg.attr('data-mo')+")");
                        checkMobile = true;
                    }
                }
            }).resize();
        }
    }
    redemption.init();
    
    if(!document.getElementById('modal_find_my_model')) return false;

    // #### modal : Find my Model category scripts
    var mainselect = document.getElementById('mainCategorySelect_fmm');
    var superselect = document.getElementById('superCategorySelect_fmm');
    var subselect = document.getElementById('subCategorySelect_fmm');
    var superMessage = "";
    var subMessage = "";
    
    var modal = {
        el: document.getElementById("modal_find_my_model"),
        form: document.getElementById("findMyModelForm"),
        submit: document.getElementById("findMyModelSubmit"),
        initFlag : "N",
        init: function(){
            
            var params = {};

            superMessage = $("#superCategorySelect_fmm option").eq(0).text();
            subMessage  = $("#subCategorySelect_fmm option").eq(0).text();
            
            // 1레벨 카테고리 셋팅
            ajax.call($("input[name='redemptionFindMyModeUrl']", ".GPC0156").val(), xssfilter(params), 'json', function (d) {
                
                var mainSelectList = d.data[0].superCateList;
                
                // 카테고리 2레벨 셋팅
                for(var i=0; i < mainSelectList.length; i++){
                    var option = "";
                    
                    option = $("<option value='"+mainSelectList[i].code+"'>"+mainSelectList[i].value+"</option>");
                    
                    $('#mainCategorySelect_fmm').append(option);
                    
                }
                
                $('#mainCategorySelect_fmm').trigger('chosen:updated');
                
            }, 'post');
            
            modal.addEvent();
        },
        addEvent: function(){
            $(modal.el).on({
                'hidden.bs.modal' : function(e){
                    if($(modal.el).find('.modal-zoom').hasClass('active')){
                        $(modal.el).find('.modal-dialog').removeClass('zoom-active');
                        $(modal.el).find('.modal-zoom').removeClass('active').attr('tabindex','-1').focus();
                    }
                }
            });         
            $(modal.form).on({
                submit: function(e){
                    e.preventDefault();
                    
                    var param = $(this).serializeArray();
                    var url = this.getAttribute('data-url');
                    
                    ajax.call(url, param, 'json', function(d){
                        var modelInfo = d.data[0].modelList[0];
                        
                        // 이미지 정보 
                        $("#findModelResult_fmm img").attr("src", modelInfo.csModelImagePathName);
                        $("#findModelResult_fmm img").attr("alt", modelInfo.csModelImageAltName);
                        $("#findModelResult_fmm .find-text").html(modelInfo.csModelNumberDesc);
                        
                        $("#modal_find_my_model .modal-zoom .pc").attr("src", modelInfo.csModelImagePathName);
                        $("#modal_find_my_model .modal-zoom .pc").attr("alt", modelInfo.csModelImageAltName);
                        
                        $("#modal_find_my_model .modal-zoom .mobile").attr("src", modelInfo.csModelImagePathName);
                        $("#modal_find_my_model .modal-zoom .mobile").attr("alt", modelInfo.csModelImageAltName);
                        
                        
                        $(modal.el).find('.find-model-results').addClass('active');
                        $(modal.el).find('.find-model-default').removeClass('active');
                        $(modal.el).modalUpdate();
                        
                        if(!!$(modal.el).find('.modal-zoom').length){
                            var imgSrc = $(modal.el).find('.find-model-results').find('.find-img img').attr('src');
                            var imgAlt = $(modal.el).find('.find-model-results').find('.find-img img').attr('alt');
                            $(modal.el).find('.zoom-area img').attr('src', imgSrc).attr('alt', imgAlt);
                            
                            $.getScript("/lg5-common-gp/library/panzoom.min.js", function(){
                                modal.zoom.init();
                            });
                        }
                        
                    });
                    
                }
            });
            
            $(mainselect).on({
                'change.base': function(){
                    
                    $(modal.el).find('.find-model-results').removeClass('active');
                    $(modal.el).find('.find-model-default').addClass('active');
                    
                    // in 외에 여기다 타야함
                    if(superselect == null){
                        
                        modal.fnSubCategoryList(this);
                        
                    } else { // 
                        
                        modal.fnSuperCategoryList(this);
                        
                        $(subselect).attr("disabled", "disabled").find("option:not(:first-child)").remove();
                        $(subselect).trigger("chosen:updated");
                    }
                    
                }
            });
            
            $(subselect).off('change.sub').on({
                'change.sub': function(){
                    $(modal.form).submit();
                }
            });
            
            /* LGEPA-220 : 20210120 add */
            $(modal.el).off('click.find-img').on({
                'click.find-img': function(e){
                    e.preventDefault();
                    e.preventDefault();
                    $(modal.el).find('.modal-dialog').addClass('zoom-active');
                    $(modal.el).find('.modal-zoom').addClass('active').attr('tabindex','0').focus();
                }
            }, 'a.find-img');
            
            $(modal.el).off('click.zoom-close').on({
                'click.zoom-close': function(e){
                    $(modal.el).find('.modal-dialog').removeClass('zoom-active');
                    $(modal.el).find('.modal-zoom').removeClass('active');
                    $(modal.el).attr('tabindex','-1');
                    $(modal.el).find('.find-img').focus();
                }
            }, '.zoom-close');
            /*// LGEPA-220 : 20210120 add */
        },
        fnSuperCategoryList : function(obj){
            var params = {};
                        
            var mainCateNo = $(obj).find(":selected").val();
            var subCateUrl = $(obj).attr("data-url");
            
            // 값셋팅
            params.productCategory = mainCateNo;
            
            $(superselect).prop("disabled", false);
            
            $('#superCategorySelect_fmm option').remove();
            
            // 카테고리 2레벨 셋팅
            
            var defaultOption = "<option value='' disabled selected>"+superMessage+"</option>";
            $(superselect).append(defaultOption);
            
            
            ajax.call(subCateUrl, xssfilter(params), 'json', function (d) {
                
                var subSelectList = d.data[0].cateList;
                
                for(var i=0; i < subSelectList.length; i++){
                    var option = "";
                    
                    option = $("<option value='"+subSelectList[i].code+"'>"+subSelectList[i].value+"</option>");
                    
                    $(superselect).append(option);
                    
                }
                
                $(superselect).trigger("chosen:updated");
                
            }, 'post');
        },
        fnSubCategoryList : function(obj){
            var params = {};
                        
            var subCateNo = $(obj).find(":selected").val();
            var subCateUrl = $(obj).attr("data-url");
            
            // 값셋팅
            if(superselect == null){
                params.productCategory = subCateNo;
            } else {
                params.findCategory = subCateNo;
            }
            
            // 버튼 비활성화
            $(subselect).prop("disabled", false);
            $('#subCategorySelect_fmm option').remove();
            
            // 카테고리 2/3레벨 초기 셋팅
            
            var defaultOption = "";
            
            defaultOption = "<option value='' disabled selected>"+subMessage+"</option>";
            
            // 초기 버튼 셋팅
            $(subselect).append(defaultOption);
            
            ajax.call(subCateUrl, xssfilter(params), 'json', function (d) {
                
                var subSelectList = d.data[0].cateList;
                
                for(var i=0; i < subSelectList.length; i++){
                    var option = "";
                    
                    option = $("<option value='"+subSelectList[i].code+"'>"+subSelectList[i].value+"</option>");
                    
                    $(subselect).append(option);
                    
                }
                
                $(subselect).trigger("chosen:updated");
                
            }, 'post');
        },
        /* LGEPA-220 : 20210120 add */
        zoom: {
            _opt : {
                option : {
                    transition: true,
                    cursor: 'inherit',
                    disablePan: false,
                    disableZoom: false,
                    disableXAxis: false,
                    disableYAxis: false,
                    which: 1,
                    increment: 0.2,
                    linearZoom: false,
                    panOnlyWhenZoomed: true,
                    minScale: 1,
                    maxScale: 2,
                    rangeStep: 0.05,
                    duration: 200,
                    contain: false,
                    onPan: function(){
                        $(this).addClass('dragged');
                    },
                    onZoom: function(){
                        var $n = $(this);
                        var matrix = $n.panzoom("getMatrix");
                        if(matrix[0] <= "1.1") {
                            if(matrix[4] != 0 && matrix[5] != 0){
                                $n.panzoom("reset");
                            }
                        }
                    }
                }
            },
            init: function(){
                var _this = modal;
                var _zoom = this;
                var zoomImg = _this.el.querySelectorAll('.zoom-area img');

                if(!_this.el.getAttribute('data-zoom-event')){
                    _this.el.setAttribute('data-zoom-event', true);
                    _zoom.addEvent();
                }
                
            },
            zoomin: function($target, opt, max){
                $target.panzoom("zoom", false, {
                    increment: max ? opt.maxScale : opt.increment,
                    animate: true
                });
                if(opt.maxScale == $target.panzoom("getMatrix")[0]){
                    $target.parent('.zoom-area').addClass('zoomout');
                }else {
                    $target.parent('.zoom-area').removeClass('zoomout');
                }
            },
            zoominpos: function(e,$target, opt, max){
                $target.panzoom("zoom", false, {
                    increment: max ? opt.maxScale : opt.increment,
                    animate: true,
                    focal:e
                });
                if(opt.maxScale == $target.panzoom("getMatrix")[0]){
                    $target.parent('.zoom-area').addClass('zoomout');
                }else {
                    $target.parent('.zoom-area').removeClass('zoomout');
                }
            },
            zoomout: function($target, opt){
                if($target.panzoom("getMatrix")[0] <= (1+opt.increment)) {
                    $target.panzoom("reset");
                }else {
                    $target.panzoom("zoom", true, {
                        increment: opt.increment,
                        animate: true
                    });
                }
                $target.parent('.zoom-area').removeClass('zoomout');
            },
            clickAction: function(e){
                var _this = modal,
                    _zoom = _this.zoom,
                    currentTarget = e.currentTarget ? e.currentTarget : e.target,
                    $target = $(currentTarget),
                    opt;

                $target.panzoom(_zoom._opt.option);
                opt = $target.panzoom("option");

                if(!$target.is('.dragged')) {
                    var $area = $target.parent('.zoom-area');
                    if(!$area.is('.zoomout')) {
                        if(e.type == 'doubletap') {
                            _zoom.zoominpos(e,$target, opt, true); // maximum zoomin
                        }else {
                            _zoom.zoominpos(e,$target, opt);
                        }
                    }else {
                        $target.panzoom('reset');
                        $area.removeClass('zoomout');
                    }
                }

                $target.removeClass('dragged');
            },
            addEvent: function(){
                var _this = modal,
                    _zoom = this;
                $(_this.el).on({
                    'click.panzoom': function(e){
                        var $target = $(_this.el).find('.zoom-area img');
                        var opt;
                        var $btn = $(e.currentTarget);

                        $target.panzoom(_zoom._opt.option);
                        opt = $target.panzoom("option");

                        if($btn.is('.plus')){
                            _zoom.zoomin($target, opt);
                        }else if($btn.is('.minus')){
                            _zoom.zoomout($target, opt);
                        }
                    }
                }, '.control button');

                if ('ontouchstart' in window){
                    // in touch device
                    var $target = $(_this.el).find('.zoom-area img');
                    for (var i = 0; i < $target.length; i++) {
                        var _target = $target.eq(i)[0];
                        var hammer = new Hammer(_target).on('doubletap', _zoom.clickAction);
                    }
                }else {
                    $(_this.el).on({
                        click: _zoom.clickAction,
                        wheel: function(e){
                            var $target = $(e.currentTarget);
                            $target.panzoom(_zoom._opt.option);
                            opt = $target.panzoom("option");
                            if(e.originalEvent.deltaY < 0) {
                                // zoom in
                                _zoom.zoomin($target, opt);
                            }else {
                                // zoom out
                                _zoom.zoomout($target, opt);
                            }
                        }
                    }, '.zoom-area img');
                }
            }
        }
        /*// LGEPA-220 : 20210120 add */
    };
    
    modal.init();
});